import Tarea from "../js/db/Tarea.js";
import LineaPedido from "../js/db/LineaPedido.js";
import Oferta from "../js/db/Oferta.js";
import Oportunidad from "../js/db/Oportunidad.js";
import Factura from "../js/db/Factura.js";

// Configuraciones para cada entidad
export const emailConfigs = {
  tarea: {
    entityName: 'tarea',
    dbAdapter: Tarea,
    plantillaSuffix: '_tarea',
    idField: 'id',
    infoHeader: null,
    remitenteOpciones: [
      {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'', action:'entradaManualCampo', params:['fromName','from']},
    ],
    destinatarioOpciones: [
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'e-mail del contacto del cliente', value:'{{$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.tarea.cliente.emailsFacturas\', \'$.pedido.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.tarea.cliente.emailsCertificados\', \'$.pedido.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
    ],
    ccOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'e-Mail del Empleado asignado', value:'{{$.empleadoAsignado.email}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.tarea.cliente.emailsFacturas\', \'$.tarea.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.tarea.cliente.emailsCertificados\', \'$.tarea.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
    ],
    ccoOpciones: [
      {name:'e-mail del usuario', value:'{{$.empleadoActual.email}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
    ],
    asuntoOpciones: [
      {name:'Recordatorio de la tarea', value:'Tarea [{{$.tarea.codigo}}]'},
      {name:'Tarea de inspeccion', value:'Tarea de inspección [{{$.tarea.codigo}}]'},
    ],
    documentosOpciones: [
      {name:'Documento de tarea', value:'Documento de tarea'},
      {name:'Informe de seguimiento', value:'Informe de seguimiento'},
      {name:'Documentación técnica', value:'Documentación técnica'},
    ]
  },

  pedido: {
    entityName: 'pedido',
    dbAdapter: LineaPedido,
    plantillaSuffix: '_linea',
    idField: 'id',
    infoHeader: '* Si no se informan destinatarios, el envío de correo se realizará a la dirección informada en el campo "Email Comunicaciones" de la línea y si este no está informado, se enviará al "email de contacto" del pedido',
    remitenteOpciones: [
      {name:'Expedientes', value:'expedientes@simecal.com', valueName:'Expedientes Simecal'},
      {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Datos del Primer inspector', value:'{{$.expediente.inspector1.email}}', valueName:'{{$.expediente.inspector1.nombre}}'},
      {name:'Datos del Empleado de contratación', value:'{{$.empleadoContratacion.email}}', valueName:'{{$.empleadoContratacion.nombre}}'},
      {name:'Entrada manual', value:'', action:'entradaManualCampo', params:['fromName','from']},
    ],
    destinatarioOpciones: [
      {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'e-mail del contacto del cliente', value:'{{$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor}}'},
      {name:'e-mail del contacto del pedido', value:'{{$.pedido.emailContacto}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.pedido.cliente.emailsFacturas\', \'$.pedido.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.pedido.cliente.emailsCertificados\', \'$.pedido.emailContacto\'])}}'},
      {name:'e-Mail de mantenedor', value:'{{$..coalesce([\'$.pedido.lineas[0].mantenedor.emails\', \'$.pedido.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
    ],
    ccOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'e-Mail del Empleado asignado', value:'{{$.empleadoAsignado.email}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.pedido.cliente.emailsFacturas\', \'$.pedido.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.pedido.cliente.emailsCertificados\', \'$.pedido.emailContacto\'])}}'},
      {name:'e-Mail de mantenedor', value:'{{$..coalesce([\'$.pedido.lineas[0].mantenedor.emails\', \'$.pedido.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
    ],
    ccoOpciones: [
      {name:'e-mail del usuario', value:'{{$.empleadoActual.email}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
    ],
    asuntoOpciones: [
      {name:'Recordatorio del pedido', value:'Pedido [{{$.lineaPedido.numero}}]'},
      {name:'Linea de pedido', value:'Línea de pedido [{{$.lineaPedido.numero}}]'},
    ],
    documentosOpciones: [
      {name:'Oferta', value:'Oferta'},
      {name:'Certificado', value:'Certificado'},
      {name:'Hoja de datos', value:'Hoja de datos'},
      {name:'Factura', value:'Factura'},
    ]
  },

  oferta: {
    entityName: 'oferta',
    dbAdapter: Oferta,
    plantillaSuffix: '_oferta',
    idField: 'id',
    infoHeader: null,
    remitenteOpciones: [
      {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'', action:'entradaManualCampo', params:['fromName','from']},
    ],
    destinatarioOpciones: [
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'e-mail del contacto del cliente', value:'{{$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.oferta.cliente.emailsFacturas\', \'$.oferta.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.oferta.cliente.emailsCertificados\', \'$.oferta.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
    ],
    ccOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'e-Mail del Empleado asignado', value:'{{$.empleadoAsignado.email}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.oferta.cliente.emailsFacturas\', \'$.oferta.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.oferta.cliente.emailsCertificados\', \'$.oferta.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
    ],
    ccoOpciones: [
      {name:'e-mail del usuario', value:'{{$.empleadoActual.email}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
    ],
    asuntoOpciones: [
      {name:'Recordatorio de la oferta', value:'Oferta [{{$.oferta.numero}}]'},
      {name:'Propuesta comercial', value:'Propuesta comercial [{{$.oferta.numero}}]'},
    ],
    documentosOpciones: [
      {name:'Oferta', value:'Oferta'},
    ]
  },

  oportunidad: {
    entityName: 'oportunidad',
    dbAdapter: Oportunidad,
    plantillaSuffix: '_oportunidad',
    idField: 'id',
    infoHeader: null,
    remitenteOpciones: [
      {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'', action:'entradaManualCampo', params:['fromName','from']},
    ],
    destinatarioOpciones: [
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'e-mail del contacto del cliente', value:'{{$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.oportunidad.cliente.emailsFacturas\', \'$.oportunidad.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.oportunidad.cliente.emailsCertificados\', \'$.oportunidad.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
    ],
    ccOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'e-Mail del Empleado asignado', value:'{{$.empleadoAsignado.email}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.oportunidad.cliente.emailsFacturas\', \'$.oportunidad.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.oportunidad.cliente.emailsCertificados\', \'$.oportunidad.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
    ],
    ccoOpciones: [
      {name:'e-mail del usuario', value:'{{$.empleadoActual.email}}'},
      {name:'Datos del Empleado asignado', value:'{{$.empleadoAsignado.email}}', valueName:'{{$.empleadoAsignado.nombre}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
    ],
    asuntoOpciones: [
      {name:'Seguimiento de oportunidad', value:'Oportunidad [{{$.oportunidad.codigo}}]'},
      {name:'Propuesta comercial', value:'Propuesta para oportunidad [{{$.oportunidad.codigo}}]'},
    ],
    documentosOpciones: []
  },

  // Para facturas (nueva configuración)
  factura: {
    entityName: 'factura',
    dbAdapter: Factura, // El adaptador de base de datos correspondiente
    plantillaSuffix: '_factura',
    idField: 'id',
    infoHeader: null,
    remitenteOpciones: [
      {name:'Datos de tu usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'Administración', value:'administracion@simecal.com', valueName:'Administración Simecal'},
      {name:'Expedientes', value:'expedientes@simecal.com', valueName:'Expedientes Simecal'},
      {name:'Entrada manual', value:'', action:'entradaManualCampo', params:['fromName','from']},
    ],
    destinatarioOpciones: [
      {name:'Datos de tu usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
      {name:'e-Mail de envio de facturas del pedido', value:'{{$..coalesce([\'$.pedido.cliente.emailsFacturas\', \'$.factura.emailContacto\'])}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.cliente.emailsFacturas\', \'$.factura.emailContacto\'])}}'},
      {name:'e-mail del contacto del cliente', value:'{{$..coalesce([\'$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor\', \'$.factura.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del cliente', value:'{{$..coalesce([\'$.cliente.emailsCertificados\', \'$.factura.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del pedido', value:'{{$..coalesce([\'$.pedido.cliente.emailsCertificados\', \'$.factura.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
    ],
    ccOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'e-mail del contacto del cliente', value:'{{$..coalesce([\'$.cliente.contactoDefectoDTO.canalesComunicacion[?(@.tipo == \'EMAIL\')].valor\', \'$.factura.emailContacto\'])}}'},
      {name:'e-Mail de envio de facturas del cliente', value:'{{$..coalesce([\'$.cliente.emailsFacturas\', \'$.factura.emailContacto\'])}}'},
      {name:'e-Mail de envio de certificados del pedido', value:'{{$..coalesce([\'$.cliente.emailsCertificados\', \'$.factura.emailContacto\'])}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
    ],
    ccoOpciones: [
      {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
      {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
    ],
    asuntoOpciones: [
      {name:'Envío de factura', value:'Factura [{{$.factura.numero}}]'},
      {name:'Recordatorio de pago', value:'Recordatorio de pago - Factura [{{$.factura.numero}}]'},
    ],
    documentosOpciones: [
      {name:'Factura', value:'Factura'},
      {name:'Certificado', value:'Certificado'},
    ]
  }
};

export default emailConfigs;
